import React, { useEffect } from "react";
import "@arco-design/web-react/dist/css/arco.css";
import LoginForm from "./form";
import "./style/style.less";
import { sm4 } from "sm-crypto";
import { observer } from "mobx-react";
import { setTokenToLocalStorage } from "@/utils/token";
import User from "@/stores/userStore";
function Login() {
  useEffect(() => {
    window.localStorage.clear();
  }, []);

  useEffect(() => {
    const key = "51792d4287ec8340a032be94848fbf0c";
    const params = new URLSearchParams(window.location.search);
    const encrypted = params.get("token");
    if (encrypted) {
      const decryptedText = sm4.decrypt(encrypted, key);
      setTokenToLocalStorage(decryptedText);
      User.getUserInfo(true);
    }
  }, []);

  return (
    <div className="container">
      <div className="box-card">
        <LoginForm />
      </div>
    </div>
  );
}
Login.displayName = "LoginPage";

export default observer(Login);
